import CharacterImg from '@/assets/images/workspace/characters.jpg'
import ScreenplayImg from '@/assets/images/workspace/screenplay.jpg'
import StoryImg from '@/assets/images/workspace/story.jpg'
import StoryboardImg from '@/assets/images/workspace/storyboard.jpg'
import V2SOptionbar from '@/features/screenplay/components/v2s/v2s-optionbar'
import ShotlistImg from '@/assets/images/workspace/shotlist.png'
export enum WorkspaceModuleTypes {
    STORY = 'story',
    CHARACTERS = 'characters',
    SCREENPLAY = 'screenplay',
    SHOTLIST = 'shotlist',
    STORYBOARD = 'storyboard',

}
export enum WorkspaceSubModuleTypes {
    SCREENPLAY_EDITOR = 'screenplay',
    STORYBOARD_V2S = 'screenplay-v2s',
}

export type ModuleConfig = {
    name: string
    description?: string
    emoji: string
    routePattern: string
    image: string | false
    isEnabled?: boolean
    subItems?: Record<WorkspaceSubModuleTypes, ModuleConfig>
    routeRegex: RegExp
    optionBar?: React.ReactNode
}

export const workspaceModules: Record<WorkspaceModuleTypes, ModuleConfig> = {
    [WorkspaceModuleTypes.STORY]: {
        name: 'Story',
        description: 'Craft the foundational narrative and plot outlines.',
        emoji: '📖',
        routePattern: '/workspace/[project_id]/story/',
        image: StoryImg,
        routeRegex: /^\/workspace\/\d+\/story\/?$/,
    },
    [WorkspaceModuleTypes.CHARACTERS]: {
        name: 'Characters',
        description: 'Develop comprehensive profiles and character arcs.',
        emoji: '🎭',
        routePattern: '/workspace/[project_id]/characters/',
        image: CharacterImg,
        routeRegex: /^\/workspace\/\d+\/characters\/?$/,
    },
    [WorkspaceModuleTypes.SCREENPLAY]: {
        name: 'Screenplay',
        description: 'Write, edit, and format your script professionally.',
        emoji: '🎬',
        routePattern: '/workspace/[project_id]/screenplay/',
        image: ScreenplayImg,
        subItems: {
            [WorkspaceSubModuleTypes.SCREENPLAY_EDITOR]: {
                name: 'v2S',
                image: false,
                emoji: '🗣️',
                routePattern: '/workspace/[project_id]/screenplay/v2s/',
                routeRegex: /^\/workspace\/\d+\/screenplay\/?$/,
            },
            [WorkspaceSubModuleTypes.STORYBOARD_V2S]: {
                name: 'Editor',
                image: false,
                emoji: '✍️',
                routePattern: '/workspace/[project_id]/screenplay/',
                routeRegex: /^\/workspace\/\d+\/screenplay\/v2s\/?$/,
                optionBar: <V2SOptionbar />,
            },
        },
        routeRegex: /^\/workspace\/\d+\/screenplay(\/(v2s|add))?\/?$/,
    },
    [WorkspaceModuleTypes.SHOTLIST]: {
        name: 'Shot List',
        description: 'Plan camera angles, movements, and shot details.',
        image: ShotlistImg,
        emoji: '🎥',
        routePattern: '/workspace/[project_id]/shotlist/',
        routeRegex: /^\/workspace\/\d+\/shotlist\/?$/,
    },
    [WorkspaceModuleTypes.STORYBOARD]: {
        name: 'Storyboard',
        description: 'Visualize your project frame by frame.',
        emoji: '📋',
        routePattern: '/workspace/[project_id]/storyboard/',
        isEnabled: true,
        image: StoryboardImg,
        routeRegex: /^\/workspace\/\d+\/storyboard\/?$/,
    },

}
